import React from "react";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";

const SelectMultiple = ({
  options,
  value,
  onChange,
  onClose,
  renderValue,
  compact = false,
  openUpward = false,
  className = "select",
}) => {
  const menuProps = {
    PaperProps: {
      style: { maxHeight: 250, marginTop: openUpward ? 0 : 30 },
    },
    getContentAnchorEl: null,
    ...(openUpward
      ? {
          anchorOrigin: { vertical: "top", horizontal: "left" },
          transformOrigin: { vertical: "bottom", horizontal: "left" },
        }
      : {}),
  };

  const defaultRenderValue = (selected) =>
    options
      .filter((option) => selected.includes(option.value))
      .map((option) => option.label)
      .join(", ");

  return (
    <Select
      className={className}
      style={{ width: "100%" }}
      multiple
      value={value}
      onChange={(event) => onChange(event.target.value)}
      onClose={onClose}
      input={<Input />}
      renderValue={renderValue || defaultRenderValue}
      MenuProps={menuProps}
    >
      {options.map((option) => (
        <MenuItem
          dense={compact}
          key={option.value}
          value={option.value}
          style={
            compact ? { minHeight: 28, paddingTop: 2, paddingBottom: 2 } : {}
          }
        >
          <Checkbox
            color="primary"
            size="small"
            checked={value.includes(option.value)}
            style={compact ? { padding: 2, marginRight: 6 } : {}}
          />
          <ListItemText
            primary={option.label}
            primaryTypographyProps={
              compact ? { style: { lineHeight: 1.2 } } : {}
            }
          />
        </MenuItem>
      ))}
    </Select>
  );
};

export default SelectMultiple;
